import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

// employeeReviews/condition API
export const conditionGets = (params = {}) =>
  http
    .get('employeeReviews/condition', { params })
    .then(res => {
      res.data.data= res.data.data.map(x => {
        x.createdAt = formatter.formatDate(x.createdAt, "HH:mm:ss DD/MM/YYYY")
        return x
      })
      return res.data
    })

export const conditionGet = id => http.get(`employeeReviews/condition/${id}`).then(res => res.data);

export const conditionPost = (payload) => http.post('employeeReviews/condition', payload);

export const conditionPut = (id, payload) => http.put(`employeeReviews/condition/${id}`, payload);

export const conditionDelete = id => http.delete(`employeeReviews/condition/${id}`);
